/**
 * DefinitionCardSkeleton
 *
 * A skeleton loading state for the DefinitionCard component
 */

import React from 'react'
import { cn } from '@/lib/utils'

interface DefinitionCardSkeletonProps {
  className?: string
}

export const DefinitionCardSkeleton: React.FC<DefinitionCardSkeletonProps> = ({ className }) => {
  return (
    <div
      className={cn(
        'border-border bg-card my-4 flex animate-pulse flex-col overflow-hidden rounded-lg border shadow-sm transition-all',
        className
      )}
    >
      {/* Header with term */}
      <div className="flex items-center border-b p-4">
        <div className="flex-1">
          <div className="mb-1 h-5 w-1/3 rounded bg-gray-200 dark:bg-gray-700"></div>
          <div className="h-3 w-1/4 rounded bg-gray-200 opacity-70 dark:bg-gray-700"></div>
        </div>
        <div className="size-8 rounded-full bg-gray-200 dark:bg-gray-700"></div>
      </div>

      {/* Definition content */}
      <div className="p-4">
        <div className="space-y-3">
          {/* Definition text */}
          <div className="space-y-2">
            <div className="h-4 w-full rounded bg-gray-200 dark:bg-gray-700"></div>
            <div className="h-4 w-5/6 rounded bg-gray-200 dark:bg-gray-700"></div>
            <div className="h-4 w-4/5 rounded bg-gray-200 dark:bg-gray-700"></div>
          </div>

          {/* Examples section */}
          <div className="mt-3 border-t pt-3">
            <div className="mb-2 h-4 w-1/4 rounded bg-gray-200 dark:bg-gray-700"></div>
            <div className="space-y-2">
              <div className="h-4 w-full rounded bg-gray-200 dark:bg-gray-700"></div>
              <div className="h-4 w-3/4 rounded bg-gray-200 dark:bg-gray-700"></div>
            </div>
          </div>

          {/* Related terms */}
          <div className="mt-3 border-t pt-3">
            <div className="mb-2 h-4 w-1/4 rounded bg-gray-200 dark:bg-gray-700"></div>
            <div className="flex flex-wrap gap-2">
              <div className="h-8 w-20 rounded-md bg-gray-200 dark:bg-gray-700"></div>
              <div className="h-8 w-24 rounded-md bg-gray-200 dark:bg-gray-700"></div>
              <div className="h-8 w-16 rounded-md bg-gray-200 dark:bg-gray-700"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
